import { render, staticRenderFns } from "./hqglOfficeBaseFurniture.vue?vue&type=template&id=93128d22&scoped=true&"
import script from "./hqglOfficeBaseFurniture.vue?vue&type=script&lang=js&"
export * from "./hqglOfficeBaseFurniture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93128d22",
  null
  
)

export default component.exports